export const tooltips = {
    incomes: [
        {
            description: "Te pedimos información de tus ingresos para poder hacerte una oferta a tu medida y asegurarnos de que puedas cubrir las cuotas cómodamente",
        },
    ],
    coborrower: [
        {
            description: "El co-titular es un familiar o amigo que se suma al préstamo como co-deudor para incrementar el nivel de ingresos totales de tu solicitud y que podamos así pre-aprobarte un monto mayor (recordá que el monto de tu préstamo se calcula de forma tal que la cuota no supere nunca un 30% de los ingresos totales declarados de todos los co-deudores).",
        },
    ],
    cuotaInicial: [
        {
            description: "En el monto de la cuota ya están contemplados todos los gastos de otorgamiento y seguros.",
        },
    ],
    dni: [
        {
            description: " Te pedimos tu DNI para analizar tu perfil crediticio. Este dato será almacenado en un servidor seguro y nunca será compartido con ninguna otra empresa.",
        },
    ],
    patente: [
        {
            description: "Te pedimos la patente para comprobar el estado de deudas de multas o patentes. Este dato será almacenado en un servidor seguro y nunca será compartido con ninguna otra empresa.",
        },
    ],
}
